import PropTypes from 'prop-types';
import React from 'react';

import FirebaseAuthContext from '../context/firebase-auth-context';
import { renderWithProps } from '../core';

const IfFirebaseUnauthed = React.memo(({ and, children }) => (
  <FirebaseAuthContext.Consumer>
    {state => {
      const { isSignedIn } = state;
      if (isSignedIn) return null;
      const isvalid = and ? and(state) : true;
      return isvalid && renderWithProps(children, state);
    }}
  </FirebaseAuthContext.Consumer>
));

IfFirebaseUnauthed.defaultProps = {
  and: null,
};

IfFirebaseUnauthed.propTypes = {
  and: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.elementType,
    PropTypes.func,
  ]).isRequired,
};

IfFirebaseUnauthed.displayName = 'IfFirebaseUnauthed';

export default IfFirebaseUnauthed;
